import React from 'react';
import RichEditor from './RichEditor';

class RichEditorField extends React.Component {
    constructor(props) {
        super(props);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleBlur() {
        this.props.field.onBlur(this.props.field.name);
    }

    handleChange(value) {
        this.props.form.setFieldValue(this.props.field.name, value);
    }

    render() {
        const {field, ...rest} = this.props;
        return (
            <RichEditor value={field.value} onBlur={this.handleBlur} onChange={this.handleChange} {...rest} />
        );
    }
}

RichEditorField.defaultProps = {
    showParameters: true,
    showExtraFields: true,
    showQuestions: true,
    questions: [],
};

export default RichEditorField;
